const heroModule = document.querySelector('.product-hero');

if (heroModule) {
  const secondaryHero = heroModule?.classList.contains('product-hero--secondary');
  const doubleImageHero = heroModule?.classList.contains('product-hero--double-image');
  const heroTimeline = gsap.timeline({ ease: 'back.inOut(2)' });

  heroTimeline.to('.product-hero__background-title', {
    duration: 1,
    ease: 'back.inOut(2)',
    autoAlpha: 1,
    y: 0,
  });

  heroTimeline.add('imageStart').to(
    '.product-hero__image img',
    {
      duration: 1,
      ease: 'back.inOut(2)',
      autoAlpha: 1,
      y: 0,
    },
    '-=0.6',
  );

  heroTimeline.to(
    ['.product-hero__title', '.product-hero__weight', '.product-hero__text', '.product-hero__button'],
    { y: 0, autoAlpha: 1, duration: 0.4, stagger: 0.03 },
    'imageStart',
  );

  heroTimeline.to('.product-hero__scroll', { autoAlpha: 1, duration: 0.4 }, 'imageStart+=0.2');

  heroTimeline.to('.product-hero__aromatics-left', {
    bottom: secondaryHero || doubleImageHero ? '0%' : '12%',
    left: secondaryHero ? '6%' : doubleImageHero ? '5%' : '-58%',
    opacity: 1,
    duration: 0.4,
  });
  heroTimeline.to(
    '.product-hero__aromatics-right',
    {
      bottom: secondaryHero ? '-19%' : doubleImageHero ? '-7%' : '8%',
      right: secondaryHero ? '-6%' : doubleImageHero ? '-7%' : '-48%',
      opacity: 1,
      duration: 0.4,
    },
    '<',
  );

  gsap.to('.product-hero__aromatics-left', {
    y: '30%',
    scrollTrigger: {
      trigger: '.product-hero',
      start: 'top 60%',
      end: 'bottom 60%',
      scrub: 3,
    },
  });

  gsap.to('.product-hero__aromatics-right', {
    y: '-20%',
    scrollTrigger: {
      trigger: '.product-hero',
      start: 'top 60%',
      end: 'bottom 60%',
      scrub: 3,
    },
  });
}
